export default "__VITE_ASSET__CVEovgnn__"